import React from "react";

const MessageReplyQuote = ({ quote, isOwnBubble = false }) => {
  if (!quote?.text) return null;

  return (
    <div className={`message-reply-quote${isOwnBubble ? " own-bubble" : ""}`}>
      <div className="message-reply-quote-name f-10">{quote.name}</div>
      <div className="message-reply-quote-text f-10">{quote.text}</div>
    </div>
  );
};

export default MessageReplyQuote;
